import t from"styled-components";import{theme as i}from"../../../../../theme.js";const o=t.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*2}px;
`;export{o as Container};
